import React from "react";
import { Box, Button } from "@mui/material";
import TableViewIcon from "@mui/icons-material/TableView";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

export default function ReportExportButtons({
  onExcel,
  onPdf,
  excelDisabled,
  pdfDisabled,
  excelLabel = "Excel Rapor",
  pdfLabel = "PDF Rapor",
  classNameExcel = "btn-primary",
  classNamePdf = "btn-soft",
}) {
  return (
    <Box display="flex" gap={1.2} flexWrap="wrap" alignItems="center">
      <Button
        variant="contained"
        className={classNameExcel}
        startIcon={<TableViewIcon />}
        onClick={onExcel}
        disabled={!!excelDisabled}
      >
        {excelLabel}
      </Button>

      <Button
        variant="contained"
        className={classNameExcel}
        startIcon={<PictureAsPdfIcon />}
        onClick={onPdf}
        disabled={!!pdfDisabled}
      >
        {pdfLabel}
      </Button>
    </Box>
  );
}
